import { z } from 'zod';

export const schemaConsorsSubscriptionResponse = z
    .object({
        errors: z.record(z.string(), z.array(z.string())).optional(),
        subscriptionidentifier: z.string().optional(),
        warning: z.record(z.string(), z.array(z.string())).optional(),
    })
    .passthrough()
    .refine(
        (data) => {
            return data.errors !== undefined || data.subscriptionidentifier !== undefined || data.warning !== undefined;
        },
        {
            message: "At least one of the keys ('errors', 'subscriptionidentifier', 'warning') must be present",
        },
    );
export type SchemaConsorsSubscriptionResponse = z.infer<typeof schemaConsorsSubscriptionResponse>;
